var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3266 6.90358C4.89113 6.46811 4.89113 5.76207 5.3266 5.3266C5.76207 4.89113 6.46811 4.89113 6.90358 5.3266L22.6734 21.0964C23.1088 21.5319 23.1088 22.2379 22.6734 22.6734C22.2379 23.1088 21.5319 23.1088 21.0964 22.6734L5.3266 6.90358Z",
    fill: "#D0342C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0964 5.32664C21.5319 4.89116 22.2379 4.89116 22.6734 5.32664C23.1089 5.76211 23.1089 6.46814 22.6734 6.90361L6.90363 22.6734C6.46816 23.1089 5.76213 23.1089 5.32666 22.6734C4.89119 22.2379 4.89119 21.5319 5.32666 21.0964L21.0964 5.32664Z",
    fill: "#D0342C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.d912ca6e9b2f0837cf95b0d9eca1c51c.svg";
export { ForwardRef as ReactComponent };